module.exports = __webpack_public_path__ + "img/dots-vertical.dba6e222.svg";